export const SUGGESTED_PEOPLE = "Suggested People";
export const OTHER_PEOPLE = "All Other People";
export const FALLBACK_PAGE_ERROR_MESSAGE = "Ooops! Nothing here...";
export const COMPANY_NAME = "ImageShield LLC.";
export const YEAR = "2024";
export const ALL_RIGHTS_RESERVED = "All right reserved";
export const CONTACT = "Contact:";
export const PHONE_NUMBER = "+91 9090401234";
export const EMAIL = "team@flashback.inc";
export const ORGANISATION_STRING = "Organisation";
export const NAME_STRING = "Name";
export const COLON_STRING = ":";
export const DESCRIPTION_STRING = "Description";
export const ESTABLISHED_NATION_STRING = "Established Nation";
export const WEBSITE_URL_STRING = "Website";
export const URL_STRING = "Url";
export const EMAIL_STRING = "Email";
export const FOUNDER_STRING = "Founder";
export const LINKEDIN_STRING = "Linkedin";
export const QAGroups = [
  [
    {
      question: "01. Scan QR Code at Event",
      answer:
        "Register with us and get your photos from this event in the next 24 hours.",
    },
    {
      question: "02. Register Your Face",
      answer:
        "Register with us and get your photos from this event in the next 24 hours.",
    },
    {
      question: "03. Get Your Memories on Whatsapp",
      answer:
        "Register with us and get your photos from this event in the next 24 hours.",
    },
  ],
  [
    {
      question: "01. Upload Photographs",
      answer:
        "Register with us and get your photos from this event in the next 24 hours.",
    },
    {
      question: "02. Confirm Relationships",
      answer:
        "Register with us and get your photos from this event in the next 24 hours.",
    },
    {
      question: "03. Create Album",
      answer:
        "Register with us and get your photos from this event in the next 24 hours.",
    },
  ],
];

export const HOW_IT_WORKS_STRING = "How it works?";
